import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../searchers";

export const FETCH_DELETE_SEARCHERS_REQUEST = 'FETCH_DELETE_SEARCHERS_REQUEST';
export const FETCH_DELETE_SEARCHERS_SUCCESS = 'FETCH_DELETE_SEARCHERS_SUCCESS';
export const FETCH_DELETE_SEARCHERS_FAILURE = 'FETCH_DELETE_SEARCHERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteSearchersRequest = () => {
    return {
        type: FETCH_DELETE_SEARCHERS_REQUEST,
    };
};

const fetchDeleteSearchersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_SEARCHERS_SUCCESS,
        payload: data
    };
};

const fetchDeleteSearchersFailure = (error: any) => {
    return {
        type: FETCH_DELETE_SEARCHERS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteSearchersRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteSearchersSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteSearchersFailure(error.message));
        }
    };
};
